import React, { Component } from 'react';
import _ from "lodash";
import moment from "moment";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import DayPicker, { DateUtils } from 'react-day-picker';
import TextAutocompleteInput from "./TextAutocompleteInput";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactCountryFlag from "react-country-flag"



import DataList from "./DataList";
import EbookPopup from './EbookPopup';
import MetaTags from 'react-meta-tags';
import track from "../lib/tracking";
import { countryList } from "../lib/utils";



class Home extends Component {

  state={
    titleSearch: "",
    distributorSearch: "",
    countrySearch: "",
    mode: "thumb",
    datepickerVisible: false,
  }

  componentDidMount(){
    this.props.getItems();
  }

  filterData = () => {
    let data = this.props.data;
    data = _.filter(data , item => item.next_release)
    
    if(!this.props.authed){
      data = _.filter(data, item => item.is_public)
    }

    if(this.state.titleSearch !== ""){
      data = _.filter(data,(item) =>  {
        return _.includes(_.toLower(item.english_title), _.toLower(this.state.titleSearch ));
      });
    }
    
    if(this.state.distributorSearch !== ""){
      data = _.filter(data,(item) =>  {
        return _.includes(_.toLower(item.search_distributor), _.toLower(this.state.distributorSearch));
      });
    }
    if(this.state.countrySearch !== ""){
      data = _.filter(data,(item) =>  {
        return _.includes(_.toLower(item.search_country), _.toLower(this.state.countrySearch ));
      });
    }
    return data;
  }
  changeMode = () => {
    this.setState( ({mode}) => {
      const newMode = mode === "list" ? "thumb" : "list";
      return ({ mode: newMode });
    });
  }

  render() {
    const data = _.sortBy(this.filterData(), o => o.next_release.valueOf());

    return (
      <div className="home">
        <MetaTags>
          <title>Homepage, Euro Film Launches</title>
          <meta name="description" content="Find out when any film is opening in European cinemas over the next twelve months" />
          <meta property="og:title" content="Homepage, Euro Film Launches" />
        </MetaTags>
        <div className="home__search">
          <div className="search">
            <label>MOVIE</label>
            <TextAutocompleteInput 
              placeholder="Movie Title"
              itemValue={ (item) => item }
              itemLabel={ (item) => item }
              itemKey={ (item) => item }
              value={this.state.titleSearch}
              items={_.chain(data).map(o => o.english_title).filter(o => o).uniq().value()}
              onChange={(v) => this.setState({titleSearch: v}) }
              onSelect={(v) =>{ track("search_header_movie",{movie_name: v});this.resultsRef.scrollIntoView({ behavior: "smooth" }); this.setState({titleSearch: v})}}
              inputHeight="23px"
            />
          </div>
          <div className="search">
            <label>DISTRIBUTOR</label>
            <TextAutocompleteInput 
              placeholder="Distributor"
              itemValue={ (item) => item }
              itemLabel={ (item) => item }
              itemKey={ (item) => item }
              value={this.state.distributorSearch}
              items={_.chain(data).map(o => o.search_distributor).filter(o => o).uniq().value()}
              onChange={(v) => this.setState({distributorSearch: v})}
              onSelect={(v) => {track("search_header_distributor",{distributor: v});this.setState({distributorSearch: v});}}
              inputHeight="23px"
            />
          </div>
          <div className="search">
            <label>COUNTRY</label>
            <TextAutocompleteInput 
              placeholder="Country"
              itemValue={ (item) => item.name }
              itemLabel={ (item) => (
                <div className="autocomplete__country">
                  <ReactCountryFlag svg countryCode={item.code.toUpperCase()} />
                  <div>{item.name}</div>
                </div>
              )}
              itemKey={ (item) => item.code }
              value={this.state.countrySearch}
              items={countryList().filter(o => _.includes(_.toLower(o.name), _.toLower(this.state.countrySearch )))}
              onChange={(v) => this.setState({countrySearch: v})}
              onSelect={(v) => { track("search_header_country",{country: v});this.setState({countrySearch: v});}}
              inputHeight="23px"
            />
          </div>
        </div>
        <div className="container"> 
          <div className="container__header">
            <div className="container__title" ref={(ref) => this.resultsRef = ref}>Upcoming Releases</div>
            <div onClick={this.changeMode} className="container__mode-button">List View</div>
          </div>
          <DataList data={data} mode={this.state.mode} authed={this.props.authed}/>
        </div>
        <EbookPopup authed={this.props.authed} />
      </div>
    );
    return <div></div>
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js